"use strict";
exports.__esModule = true;
exports.DesignerCatalogExplorer = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var AccessoryModel_1 = require("./AccessoryModel");
var Design_1 = require("./Design");
var DesignerCatalog_1 = require("./DesignerCatalog");
var DesignerFeature_1 = require("./DesignerFeature");
var PieceModel_1 = require("./PieceModel");
var DesignerCatalogExplorer = /** @class */ (function () {
    function DesignerCatalogExplorer(designerCatalog, currentDesignerProductCollectionId, currentDesignerProductId, currentDesignerPieceVariant, currentDesignerAccessoryVariantId) {
        this.cachedAvailableSymbols = [];
        this.cachedAvailableSymbolsToSymbolCollectionMapping = new Map();
        this.cachedAvailablePieceVariantsToProductMapping = new Map();
        this.cachedAvailableAccessoryVariantsToProductMapping = new Map();
        this.cachedAvailablePieceVariantsInCollection = [];
        this.cachedAvailableAccessoryVariantsInCollection = [];
        this.designerCatalog = designerCatalog;
        this.setCurrentDesignerProductCollection(currentDesignerProductCollectionId);
        this.setCurrentDesignerProductVariant(currentDesignerProductId, currentDesignerPieceVariant, currentDesignerAccessoryVariantId);
        this.cachedAvailableSymbols = this.computeAvailableSymbols();
        this.cachedAvailableSymbolsToSymbolCollectionMapping = this.computeAvailableSymbolsToSymbolCollection();
        this.cachedAvailablePieceVariantsToProductMapping = this.computeAvailablePieceVariantsToProductMapping();
        this.cachedAvailableAccessoryVariantsToProductMapping = this.computeAvailableAccessoryVariantsToProductMapping();
        this.cachedAvailablePieceVariantsInCollection = this.currentDesignerProductCollection.products
            .map(function (product) { return product.pieceVariants; })
            .reduce(function (c1, c2) { return c1.concat(c2); });
        this.cachedAvailableAccessoryVariantsInCollection = this.currentDesignerProductCollection.products
            .map(function (product) { return product.accessoryVariants; })
            .reduce(function (c1, c2) { return c1.concat(c2); });
    }
    DesignerCatalogExplorer.prototype.computeAvailablePieceVariantsToProductMapping = function () {
        var result = new Map();
        for (var _i = 0, _a = this.currentDesignerProductCollection.products; _i < _a.length; _i++) {
            var product = _a[_i];
            for (var _b = 0, _c = product.pieceVariants; _b < _c.length; _b++) {
                var pieceVariant = _c[_b];
                result.set(pieceVariant.id, product);
            }
        }
        return result;
    };
    DesignerCatalogExplorer.prototype.computeAvailableAccessoryVariantsToProductMapping = function () {
        var result = new Map();
        for (var _i = 0, _a = this.currentDesignerProductCollection.products; _i < _a.length; _i++) {
            var product = _a[_i];
            for (var _b = 0, _c = product.accessoryVariants; _b < _c.length; _b++) {
                var accessoryVariant = _c[_b];
                result.set(accessoryVariant.id, product);
            }
        }
        return result;
    };
    DesignerCatalogExplorer.prototype.computeAvailableSymbols = function () {
        var availableSymbolIds = this.getAvailableSymbolCollections()
            .map(function (sc) { return sc.symbols; })
            .reduce(function (c1, c2) { return c1.concat(c2); });
        return this.designerCatalog.availableSymbols.filter(function (symbol) { return availableSymbolIds.includes(symbol.id); });
    };
    DesignerCatalogExplorer.prototype.computeAvailableSymbolsToSymbolCollection = function () {
        var result = new Map();
        var symbolCollections = this.getAvailableSymbolCollections();
        for (var _i = 0, symbolCollections_1 = symbolCollections; _i < symbolCollections_1.length; _i++) {
            var symbolCollection = symbolCollections_1[_i];
            for (var _a = 0, _b = symbolCollection.symbols; _a < _b.length; _a++) {
                var symbolId = _b[_a];
                result.set(symbolId, symbolCollection);
            }
        }
        return result;
    };
    DesignerCatalogExplorer.prototype.getViewer3DEnvironment = function () {
        return DesignerCatalog_1.DesignerCatalog.getViewer3DEnvironment(this.designerCatalog);
    };
    DesignerCatalogExplorer.prototype.setDesignerThemeOverride = function (theme) {
        DesignerCatalog_1.DesignerCatalog.setDesignerThemeOverride(this.designerCatalog, theme);
    };
    DesignerCatalogExplorer.prototype.getDesignerTheme = function () {
        return DesignerCatalog_1.DesignerCatalog.getDesignerTheme(this.designerCatalog);
    };
    DesignerCatalogExplorer.prototype.getDefaultLanguage = function () {
        return DesignerCatalog_1.DesignerCatalog.getDefaultLanguage(this.designerCatalog);
    };
    DesignerCatalogExplorer.prototype.getDefaultPointOfView3D = function (side) {
        if (side === void 0) { side = Design_1.Side.FRONT; }
        return DesignerCatalog_1.DesignerCatalog.getDefaultPointOfView3D(this.designerCatalog, side);
    };
    DesignerCatalogExplorer.prototype.getCurrentPiece = function () {
        var _this = this;
        return this.designerCatalog.availablePieces.find(function (p) { return p.id === _this.getCurrentDesignerPieceVariant().pieceId; });
    };
    DesignerCatalogExplorer.prototype.getCurrentPieceModel = function () {
        var _this = this;
        return this.getCurrentPiece().models.find(function (m) {
            return m.sizeType === _this.getCurrentDesignerPieceVariant().pieceConfiguration.sizeType &&
                m.stonesPlacementType === _this.getCurrentDesignerPieceVariant().pieceConfiguration.stonesPlacementType;
        });
    };
    DesignerCatalogExplorer.prototype.getCurrentAccessory = function () {
        var _this = this;
        return this.designerCatalog.availableAccessories.find(function (a) { return a.id === _this.getCurrentDesignerAccessoryVariant().accessoryId; });
    };
    DesignerCatalogExplorer.prototype.getCurrentAccessoryModel = function () {
        var _this = this;
        return this.getCurrentAccessory().models.find(function (m) { return m.sizeType === _this.getCurrentDesignerAccessoryVariant().accessoryConfiguration.sizeType; });
    };
    DesignerCatalogExplorer.prototype.getCurrentDesignerProduct = function () {
        return this.currentDesignerProduct;
    };
    DesignerCatalogExplorer.prototype.getCurrentDesignerPieceVariant = function () {
        return this.currentDesignerPieceVariant;
    };
    DesignerCatalogExplorer.prototype.getCurrentDesignerAccessoryVariant = function () {
        return this.currentDesignerAccessoryVariant;
    };
    DesignerCatalogExplorer.prototype.setCurrentDesignerProductCollection = function (newDesignerProductCollectionId) {
        var _a;
        this.currentDesignerProductCollection = (_a = this.designerCatalog.availableCollections.find(function (c) { return c.id === newDesignerProductCollectionId; })) !== null && _a !== void 0 ? _a : this.currentDesignerProductCollection;
    };
    DesignerCatalogExplorer.prototype.setCurrentDesignerProductVariant = function (currentDesignerProductId, currentDesignerPieceVariantId, currentDesignerAccessoryVariantId) {
        var _a, _b, _c;
        this.currentDesignerProduct = (_a = this.currentDesignerProductCollection.products.find(function (p) { return p.id === currentDesignerProductId; })) !== null && _a !== void 0 ? _a : this.currentDesignerProduct;
        this.currentDesignerPieceVariant = (_b = this.currentDesignerProduct.pieceVariants.find(function (v) { return v.id === currentDesignerPieceVariantId; })) !== null && _b !== void 0 ? _b : this.currentDesignerPieceVariant;
        this.currentDesignerAccessoryVariant = (_c = this.currentDesignerProduct.accessoryVariants.find(function (v) { return v.id === currentDesignerAccessoryVariantId; })) !== null && _c !== void 0 ? _c : this.currentDesignerAccessoryVariant;
    };
    DesignerCatalogExplorer.prototype.getProductAndVariants = function (pieceId, accessoryId, pieceConfiguration, accessoryConfiguration) {
        var matchingPieceVariants = this.cachedAvailablePieceVariantsInCollection.filter(function (pv) { return pv.pieceId === pieceId && PieceModel_1.PieceConfiguration.identical(pv.pieceConfiguration, pieceConfiguration); });
        var matchingAccessoryVariants = this.cachedAvailableAccessoryVariantsInCollection.filter(function (av) {
            return av.accessoryId === accessoryId &&
                AccessoryModel_1.AccessoryConfiguration.identical(av.accessoryConfiguration, accessoryConfiguration);
        });
        /* Find the product with matching piece variant & accessory variant */
        for (var _i = 0, matchingPieceVariants_1 = matchingPieceVariants; _i < matchingPieceVariants_1.length; _i++) {
            var pieceVariant = matchingPieceVariants_1[_i];
            for (var _a = 0, matchingAccessoryVariants_1 = matchingAccessoryVariants; _a < matchingAccessoryVariants_1.length; _a++) {
                var accessoryVariant = matchingAccessoryVariants_1[_a];
                var pieceProduct = this.cachedAvailablePieceVariantsToProductMapping.get(pieceVariant.id);
                var accessoryProduct = this.cachedAvailableAccessoryVariantsToProductMapping.get(accessoryVariant.id);
                if (pieceProduct.id === accessoryProduct.id) {
                    return {
                        designerProduct: pieceProduct,
                        designerPieceVariant: pieceVariant,
                        designerAccessoryVariant: accessoryVariant
                    };
                }
            }
        }
        throw new core_common_domain_1.Exception("Cannot retrieve product and variants because could not find a product that matches both the expected piece & accessory configs. \n        piece id=" + pieceId + ",piece config = " + JSON.stringify(pieceConfiguration) + ", accessory id=" + accessoryId + ",accessory config = " + JSON.stringify(accessoryConfiguration) + " ");
    };
    DesignerCatalogExplorer.prototype.getFontById = function (fontId) {
        return this.getAvailableFonts().find(function (f) { return f.id === fontId; });
    };
    DesignerCatalogExplorer.prototype.getAvailableFonts = function () {
        var _this = this;
        return this.designerCatalog.availableFonts.filter(function (font) {
            return _this.currentDesignerProductCollection.availableFontIds.includes(font.id);
        });
    };
    DesignerCatalogExplorer.prototype.getAvailableFontsForEngravingType = function (engravingType) {
        var fontIdIncluded = [];
        switch (engravingType) {
            case Design_1.EngravingType.SINGLE_LETTER:
                var singleLetterDesignerFeature = this.designerCatalog.availableCollections[0].availableDesignerFeatures.find(function (df) { return df.type === DesignerFeature_1.DesignerFeatureType.SINGLE_LETTER; });
                if (singleLetterDesignerFeature === undefined)
                    throw new core_common_domain_1.Exception("Cannot find a designer feature with type " + DesignerFeature_1.DesignerFeatureType.SINGLE_LETTER + " necessary to get the available fonts for the " + Design_1.EngravingType.SINGLE_LETTER + " engraving type");
                fontIdIncluded = singleLetterDesignerFeature.singleLetterFeatureConfiguration.availableFontIds;
                break;
            case Design_1.EngravingType.TEXT:
                var textDesignerFeature = this.designerCatalog.availableCollections[0].availableDesignerFeatures.find(function (df) { return df.type === DesignerFeature_1.DesignerFeatureType.TEXT; });
                if (textDesignerFeature === undefined)
                    throw new core_common_domain_1.Exception("Cannot find a designer feature with type " + DesignerFeature_1.DesignerFeatureType.TEXT + " necessary to get the available fonts for the " + Design_1.EngravingType.TEXT + " engraving type");
                fontIdIncluded = textDesignerFeature.textFeatureConfiguration.availableFontIds;
                break;
            default:
                fontIdIncluded = this.getAvailableFonts().map(function (f) { return f.id; });
                break;
        }
        return this.getAvailableFonts().filter(function (f) { return fontIdIncluded.includes(f.id); });
    };
    DesignerCatalogExplorer.prototype.getSymbolById = function (symbolId) {
        return this.getAvailableSymbols().find(function (s) { return s.id === symbolId; });
    };
    DesignerCatalogExplorer.prototype.getAvailableSymbols = function () {
        return this.cachedAvailableSymbols;
    };
    DesignerCatalogExplorer.prototype.getAvailableSymbolCollections = function () {
        var _this = this;
        return this.designerCatalog.availableSymbolCollections.filter(function (sc) {
            return _this.currentDesignerProductCollection.availableSymbolCollectionIds.includes(sc.symbolCollectionId);
        });
    };
    DesignerCatalogExplorer.prototype.getSymbolCollectionSymbols = function (id) {
        var _this = this;
        var symbolIds = this.designerCatalog.availableSymbolCollections.find(function (sc) { return sc.id === id; })
            .symbols;
        return symbolIds.map(function (symbolId) {
            return _this.designerCatalog.availableSymbols.find(function (s) { return s.id === symbolId; });
        });
    };
    DesignerCatalogExplorer.prototype.getAvailablePieces = function () {
        return this.designerCatalog.availablePieces;
    };
    DesignerCatalogExplorer.prototype.getAvailableAccessories = function () {
        return this.designerCatalog.availableAccessories;
    };
    /**
     * The assumption is that all accessories are available in a uniform way for all pieces and the other way around.
     * As such the piece size is the "top level" constraint for a piece.
     */
    DesignerCatalogExplorer.prototype.getAvailablePieceSizes = function () {
        return Array.from(new Set(this.cachedAvailablePieceVariantsInCollection.map(function (v) { return v.pieceConfiguration.sizeType; })));
    };
    /**
     * The assumption is that all accessories are available in a uniform way for all pieces and the other way around.
     * As such the current piece size is the only constraint for the piece materials.
     */
    DesignerCatalogExplorer.prototype.getAvailablePieceMaterials = function () {
        var _this = this;
        return Array.from(new Set(this.cachedAvailablePieceVariantsInCollection
            .filter(function (v) {
            return v.pieceConfiguration.sizeType === _this.currentDesignerPieceVariant.pieceConfiguration.sizeType;
        })
            .map(function (v) { return v.pieceConfiguration.materialType; })));
    };
    /**
     * The assumption is that all accessories are available in a uniform way for all pieces and the other way around.
     * As such the current piece size & material type are the only constraints for the piece stones placement type.
     */
    DesignerCatalogExplorer.prototype.getAvailablePieceStonesPlacement = function () {
        var _this = this;
        return Array.from(new Set(this.cachedAvailablePieceVariantsInCollection
            .filter(function (v) {
            return v.pieceConfiguration.sizeType ===
                _this.currentDesignerPieceVariant.pieceConfiguration.sizeType &&
                v.pieceConfiguration.materialType ===
                    _this.currentDesignerPieceVariant.pieceConfiguration.materialType;
        })
            .map(function (v) { return v.pieceConfiguration.stonesPlacementType; })));
    };
    /**
     * The assumption is that all accessories are available in a uniform way for all pieces and the other way around.
     * As such the current piece size & material type & stones placement type are the only constraints for the piece plating types.
     */
    DesignerCatalogExplorer.prototype.getAvailablePiecePlating = function () {
        var _this = this;
        return Array.from(new Set(this.cachedAvailablePieceVariantsInCollection
            .filter(function (v) {
            return v.pieceConfiguration.sizeType ===
                _this.currentDesignerPieceVariant.pieceConfiguration.sizeType &&
                v.pieceConfiguration.materialType ===
                    _this.currentDesignerPieceVariant.pieceConfiguration.materialType &&
                v.pieceConfiguration.stonesPlacementType ===
                    _this.currentDesignerPieceVariant.pieceConfiguration.stonesPlacementType;
        })
            .map(function (v) { return v.pieceConfiguration.platingType; })));
    };
    /**
     * The assumption is that all accessories are available in a uniform way for all pieces and the other way around.
     * As such the accessory size is the "top level" constraint for a accessory.
     */
    DesignerCatalogExplorer.prototype.getAvailableAccessorySizes = function () {
        return Array.from(new Set(this.cachedAvailableAccessoryVariantsInCollection.map(function (v) { return v.accessoryConfiguration.sizeType; })));
    };
    /**
     * The assumption is that all accessories are available in a uniform way for all pieces and the other way around.
     * As such the current accessory size is the only constraint for the accessory materials.
     */
    DesignerCatalogExplorer.prototype.getAvailableAccessoryMaterials = function () {
        var _this = this;
        return Array.from(new Set(this.cachedAvailableAccessoryVariantsInCollection
            .filter(function (v) {
            return v.accessoryConfiguration.sizeType ===
                _this.currentDesignerAccessoryVariant.accessoryConfiguration.sizeType;
        })
            .map(function (v) { return v.accessoryConfiguration.materialType; })));
    };
    /**
     * The assumption is that all accessories are available in a uniform way for all pieces and the other way around.
     * As such the current accessory size & material type are the only constraints for the accessory plating types.
     */
    DesignerCatalogExplorer.prototype.getAvailableAccessoryPlating = function () {
        var _this = this;
        return Array.from(new Set(this.cachedAvailableAccessoryVariantsInCollection
            .filter(function (v) {
            return v.accessoryConfiguration.sizeType ===
                _this.currentDesignerAccessoryVariant.accessoryConfiguration.sizeType &&
                v.accessoryConfiguration.materialType ===
                    _this.currentDesignerAccessoryVariant.accessoryConfiguration.materialType;
        })
            .map(function (v) { return v.accessoryConfiguration.platingType; })));
    };
    DesignerCatalogExplorer.prototype.getPieceVariantWithConfig = function (pieceConfiguration) {
        return this.cachedAvailablePieceVariantsInCollection.find(function (v) {
            return PieceModel_1.PieceConfiguration.identical(v.pieceConfiguration, pieceConfiguration);
        });
    };
    DesignerCatalogExplorer.prototype.getAccessoryVariantWithConfig = function (accessoryConfiguration) {
        return this.cachedAvailableAccessoryVariantsInCollection.find(function (v) {
            return AccessoryModel_1.AccessoryConfiguration.identical(v.accessoryConfiguration, accessoryConfiguration);
        });
    };
    /*
     * Return all the accesories in the current collection that match the current accessory configuration.
     * This is usefull for the accessories catalog browser.
     * The assumption is that all accessories are available in a uniform way for all pieces.
     * */
    DesignerCatalogExplorer.prototype.getAvailableAccessoriesInCollection = function () {
        var _this = this;
        var accessoryVariants = this.getCurrentDesignerProduct().accessoryVariants.filter(function (v) {
            return AccessoryModel_1.AccessoryConfiguration.identical(v.accessoryConfiguration, _this.currentDesignerAccessoryVariant.accessoryConfiguration);
        });
        return accessoryVariants.map(function (variant) {
            var currentAccessory = _this.designerCatalog.availableAccessories.find(function (a) { return a.id === variant.accessoryId; });
            return {
                accessoryTitle: currentAccessory.title,
                accessoryDescription: currentAccessory.description,
                accessoryVariant: variant,
                accessory: currentAccessory,
                accessoryModel: currentAccessory.models.find(function (am) { return am.sizeType === variant.accessoryConfiguration.sizeType; })
            };
        });
    };
    /**
     * Returns all pieces in the current collection that match the current piece configuration.
     * This is usefull for the pieces catalog browser.
     */
    DesignerCatalogExplorer.prototype.getAvailablePiecesInCollection = function () {
        var _this = this;
        return this.cachedAvailablePieceVariantsInCollection
            .filter(function (pv) {
            return PieceModel_1.PieceConfiguration.identical(pv.pieceConfiguration, _this.currentDesignerPieceVariant.pieceConfiguration);
        })
            .map(function (pieceVariant) {
            var currentProduct = _this.cachedAvailablePieceVariantsToProductMapping.get(pieceVariant.id);
            var currentPiece = _this.designerCatalog.availablePieces.find(function (p) { return p.id === pieceVariant.pieceId; });
            return {
                pieceTitle: currentProduct.title,
                pieceDescription: currentProduct.description,
                pieceVariant: pieceVariant,
                piece: currentPiece,
                pieceModel: currentPiece.models.find(function (pm) {
                    return pm.sizeType === pieceVariant.pieceConfiguration.sizeType &&
                        pm.stonesPlacementType === pieceVariant.pieceConfiguration.stonesPlacementType;
                })
            };
        });
    };
    DesignerCatalogExplorer.prototype.getCurrentDesignerCatalogReference = function () {
        return {
            catalogId: this.designerCatalog.id,
            productCollectionId: this.currentDesignerProductCollection.id,
            productId: this.getCurrentDesignerProduct().id,
            accessoryVariantId: this.getCurrentDesignerAccessoryVariant().id,
            pieceVariantId: this.getCurrentDesignerPieceVariant().id
        };
    };
    DesignerCatalogExplorer.prototype.getDesignerProductShopReferenceByShopProductId = function (webshopProductId) {
        return this.designerCatalog.webshopCatalogReferences.find(function (ref) { return ref.webshopProductId === webshopProductId; });
    };
    DesignerCatalogExplorer.prototype.getCurrentDesignerProductShopReference = function () {
        var currentReference = this.getCurrentDesignerCatalogReference();
        for (var _i = 0, _a = this.designerCatalog.webshopCatalogReferences; _i < _a.length; _i++) {
            var shopReference = _a[_i];
            var variantIdx = shopReference.variants.findIndex(function (variant) {
                return variant.allAccessoryVariantIds.includes(currentReference.accessoryVariantId) &&
                    variant.allPieceVariantIds.includes(currentReference.pieceVariantId);
            });
            if (variantIdx !== -1) {
                return {
                    webshopProductReference: shopReference,
                    webshopProductVariantReference: shopReference.variants[variantIdx]
                };
            }
        }
        throw new core_common_domain_1.Exception("The current product designer reference does not point to any existing product webshop reference. Publish the catalog again to fix this.");
    };
    DesignerCatalogExplorer.prototype.getFirstSymbolCollectionWithSymbol = function (symbolId) {
        return this.cachedAvailableSymbolsToSymbolCollectionMapping.get(symbolId);
    };
    DesignerCatalogExplorer.prototype.getPieceByDesignerPieceVariant = function (pieceVariantId) {
        var _loop_1 = function (product) {
            var pieceVariant = product.pieceVariants.find(function (pv) { return pv.id === pieceVariantId; });
            if (pieceVariant) {
                return { value: this_1.getAvailablePieces().find(function (p) { return p.id === pieceVariant.pieceId; }) };
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this.currentDesignerProductCollection.products; _i < _a.length; _i++) {
            var product = _a[_i];
            var state_1 = _loop_1(product);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return undefined;
    };
    DesignerCatalogExplorer.prototype.getDesignerAccessoryVariantByPieceAndAccessoryAndConfiguration = function (pieceId, accessoryId, accessoryConfiguration) {
        /* Find the product with the right piece id */
        var product = this.currentDesignerProductCollection.products.find(function (p) { return p.pieceVariants.findIndex(function (pv) { return pv.pieceId === pieceId; }) !== -1; });
        if (product) {
            return product.accessoryVariants.find(function (av) {
                return av.accessoryId === accessoryId &&
                    AccessoryModel_1.AccessoryConfiguration.identical(av.accessoryConfiguration, accessoryConfiguration);
            });
        }
        return undefined;
    };
    DesignerCatalogExplorer.prototype.getPieceModel = function (pieceId, pieceModelId) {
        var piece = this.getAvailablePieces().find(function (p) { return p.id === pieceId; });
        if (!piece)
            throw new core_common_domain_1.Exception("Cannot find piece " + pieceId);
        return piece.models.find(function (pm) { return pm.id === pieceModelId; });
    };
    DesignerCatalogExplorer.prototype.getEditableArea = function (pieceId, pieceModelId, editableAreaId) {
        var pieceModel = this.getPieceModel(pieceId, pieceModelId);
        if (!pieceModel)
            throw new core_common_domain_1.Exception("Cannot find piece model " + pieceModelId + " inside piece " + pieceId);
        return pieceModel.editableAreas.find(function (ea) { return ea.id === editableAreaId; });
    };
    DesignerCatalogExplorer.prototype.getDesignerApplicationConfiguration = function () {
        return this.designerCatalog.designerApplicationConfiguration;
    };
    DesignerCatalogExplorer.prototype.getCurrentPieceModelEditableAreasOnEditableSides = function () {
        var editableSides = this.designerCatalog.designerApplicationConfiguration.sideConfig.filter(function (sc) { return sc.editable === true; });
        return this.getCurrentPieceModel().editableAreas.filter(function (ea) { return editableSides.find(function (editableSide) { return editableSide.side === ea.side; }); });
    };
    return DesignerCatalogExplorer;
}());
exports.DesignerCatalogExplorer = DesignerCatalogExplorer;
